import React from 'react';
import { UIWindowModal } from '../modals';
import { UITabBlock } from '../basic';
import { useLang } from '../../../_LangContext';
import { mergeClasses } from '@griffel/react';

// Type 1 (icon) - Facilities
const legends1 = [
	"info",
	"wc",
	"bf",
	"ostomate",
	"babybed",
	"nursing",
	"aed",
	"elevator",
	"phone",
	"cafe",
	"restaurant",
	"wifi",
	"restarea",
	"smoking",
	"restricted",
	"backyard"
];

// Type 2 (legend) - Accessibility
const legends2 = [
	"stairs",
	"step",
	"soil",
	"cobble",
	"slope",
	"incline",
	"e-slope",
	"e-step",
	"closed",
	"restricted-area"
];

const renderLegendItems = (legendKeys, getLocalizedTextSync) =>
{
	return (
		<div className="legend-items">
			{legendKeys.map(key =>
			{
				// Determine image type based on which array the key belongs to
				// Special case: backyard is in facilities but uses legend_ prefix
				let img_type;
				if (key === "backyard") {
					img_type = "legend";
				} else {
					img_type = legends1.includes(key) ? "icon" : "legend";
				}
				
				const img_src = `${process.env.PUBLIC_URL}/img/${img_type}_${key}.png`;
				const altText = getLocalizedTextSync(key);

				return (
					<div key={key} className="legend-item">
						<div className="item-icons">
							{key == 'incline' && (
							<div className="item-icon icon incline">
								<p className="degrees">10°</p>
								<img src={`${process.env.PUBLIC_URL}/img/icon_incline.png`} alt={altText} />
							</div>	
							)}
							<div className={mergeClasses("item-icon", img_type)}>
								<img src={img_src} alt={altText} />
							</div>
						</div>
						<div className="item-name">
							{altText}
						</div>
					</div>
				);
			})}
		</div>
	);
};

const ModalLegends = ({ isOpen, onClose }) =>
{
	const { getLocalizedTextSync } = useLang();

	const tabs = [
		{
			label: getLocalizedTextSync("accessibility"),
			className: "accessibility",
			content: renderLegendItems(legends2, getLocalizedTextSync)
		},
		{
			label: getLocalizedTextSync("facilities"),
			className: "facilities",
			content: renderLegendItems(legends1, getLocalizedTextSync)
		}
	];

	return (
		<UIWindowModal className='legends' isOpen={isOpen} onClose={onClose}>
			<div className="modal-container">
				<div className="modal-container-inner">
					<UITabBlock
						tabs={tabs}
						hasNavigate={false}
					/>
				</div>
			</div>
		</UIWindowModal>
	);
};

export default ModalLegends;
